import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const PortalsPlatformObjectIdContext = /*#__PURE__*/createContext(undefined);
export function PortalsPlatformObjectIdProvider({
  children,
  objectId
}) {
  return /*#__PURE__*/_jsx(PortalsPlatformObjectIdContext.Provider, {
    value: objectId,
    children: children
  });
}
export function usePortalsPlatformObjectId() {
  return useContext(PortalsPlatformObjectIdContext);
}